import { useContext } from 'react';
import type { FieldValues } from 'react-hook-form';
import type { DataManagementContextType } from '../interfaces/DataManagementContextType';
import { DataManagementContext } from '../types/DataManagementContext';

/**
 * @group Hooks
 * @summary Use data management context
 * 
 * <blockquote>
 * Hook to access the data management context
 * </blockquote>
 * 
 * @returns {DataManagementContextType<TData> | null} The data management context or null if not found
 */
export function useDataManagementContext<TData extends FieldValues>(): DataManagementContextType<TData> | null {
  const context = useContext(DataManagementContext);
  return context as DataManagementContextType<TData> | null;
} 